<template>
    <div>
        <q-card class="bordered no-shadow" bordered>
        <q-splitter class="alto-step bordered " bordered v-model="splitterModel">
            <template v-slot:before>
                <q-tabs v-model="tab" vertical  class="alto-step text-justify text-primary shadow-2"   align="justify">
                    <q-tab  name="AVISO" label="Aviso de Privacidad"  icon="mail" style="height:120px"/>
                    <q-separator/>
                    <q-tab name="mails" label="Estudio Socioeconomico" icon="mail" style="height:120px"/>
                    <q-separator/>

                    <q-tab name="Nota" label="Nota Médica" style="height:120px"/>
                    <q-separator/>

                    <q-tab name="Visita" label="Visita Domiciliaria" icon="mail" style="height:120px"/>
                    <q-separator/>

                   
                </q-tabs>
            </template>

            <template v-slot:after>
                <q-tab-panels v-model="tab" animated swipeable inline-label transition-prev="jump-up"
                    transition-next="jump-up">
                    <q-tab-panel name="AVISO">
                        <AvisoPrivacidad></AvisoPrivacidad>
                    </q-tab-panel>
                    <q-tab-panel name="mails">
                        <EstudioSocioEconomico></EstudioSocioEconomico>
                    </q-tab-panel>
                    <q-tab-panel name="Visita">
                        <VisitaDomiciliaria></VisitaDomiciliaria>
                    </q-tab-panel>
                    <q-tab-panel name="Nota">
                        <NotaMedica></NotaMedica>
                    </q-tab-panel>
                </q-tab-panels>
            </template>

        </q-splitter>
        </q-card>
    </div>
</template>
<script setup>
import { ref } from "vue";
import { useStore } from 'vuex'
import { computed } from 'vue'
import axios from 'axios'
import { Notify, useQuasar, QSpinnerFacebook } from 'quasar'
import EstudioSocioEconomico from './EstudioSocioEconomico.vue'
import AvisoPrivacidad from './AvisoPrivacidad.vue'
import VisitaDomiciliaria from './VisitaDomiciliaria.vue'
import NotaMedica from './NotaMedica.vue'

const $q = useQuasar()
const store = useStore()

const tab = ref('AVISO');
const splitterModel = ref(20);

const paciente = computed({
    get: () => store.state.pacienteStore,
    set: (val) => store.state.pacienteStore = val
})

 

</script>
<style>
.alto-step{
    height: 100%; overflow-y: auto
}
</style>